/* CDS Anim — animation de revelation partagee (IntersectionObserver) */
(function () {
  'use strict';

  if (window.CDSAnim) { return; }

  /* Declenchement des que l'element a penetre de 10% du viewport (rootMargin
     negatif + threshold 0). Un threshold proportionnel a la hauteur (ex 0.15)
     devient inatteignable sur les elements plus hauts que ~6 viewports
     (article complet, FAQ, grille favoris) : le contenu resterait invisible. */
  var IO_OPTIONS = { threshold: 0, rootMargin: '0px 0px -10% 0px' };

  function prefersReducedMotion() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) {
      return false;
    }
  }

  function revealNow(el) {
    var cls = el.getAttribute('data-cds-anim');
    if (!cls) { return; }
    el.classList.add(cls);
    el.dataset.cdsAnimDone = '1';
  }

  function observe(el) {
    /* try/catch : certains navigateurs in-app (Instagram, Facebook)
       exposent un IntersectionObserver casse. Un throw = revelation
       immediate plutot qu'un contenu invisible. */
    try {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            if (!entry.target.dataset.cdsAnimDone) {
              revealNow(entry.target);
            }
            io.unobserve(entry.target);
          }
        }
      }, IO_OPTIONS);
      io.observe(el);
    } catch (e) {
      revealNow(el);
    }
  }

  /* ==== Filet anti WebView in-app (Instagram, Facebook...) ====
     Bug documente : l'IntersectionObserver existe mais ne tire JAMAIS
     -> les sections restent en opacity 0, page "vide". Detection : si
     un element observe est manifestement DANS le viewport et toujours
     pas revele apres le delai de grace, l'observer est gele -> on
     revele TOUT (il ne tirera pas non plus au scroll) et on cesse de
     surveiller. Si l'observer marche, aucun element visible ne reste
     non-revele : le filet ne se declenche jamais et les animations
     d'entree au scroll restent intactes. */
  var watched = [];
  var ioBroken = false;

  function elementInViewport(el) {
    try {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return rect.top < vh && rect.bottom > 0 && (rect.width > 0 || rect.height > 0);
    } catch (e) {
      return true;
    }
  }

  function revealEverything() {
    if (ioBroken) { return; }
    ioBroken = true;
    for (var i = 0; i < watched.length; i++) {
      if (!watched[i].dataset.cdsAnimDone) { revealNow(watched[i]); }
    }
    watched.length = 0;
    window.removeEventListener('scroll', onScrollCheck);
  }

  function checkStuck() {
    if (ioBroken) { return; }
    for (var i = 0; i < watched.length; i++) {
      var el = watched[i];
      if (!el.dataset.cdsAnimDone && elementInViewport(el)) {
        revealEverything();
        return;
      }
    }
  }

  var scrollCheckTimer = null;
  function onScrollCheck() {
    if (scrollCheckTimer) { return; }
    scrollCheckTimer = window.setTimeout(function () {
      scrollCheckTimer = null;
      checkStuck();
    }, 400);
  }

  function armWatchdog() {
    window.setTimeout(checkStuck, 3000);
    window.addEventListener('scroll', onScrollCheck, { passive: true });
  }
  armWatchdog();

  function scan(root) {
    var scope = root || document;
    if (typeof scope.querySelectorAll !== 'function') { return; }
    var els = scope.querySelectorAll('[data-cds-anim]');
    if (!els.length) { return; }
    var reduced = prefersReducedMotion();
    var hasIO = 'IntersectionObserver' in window;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.cdsAnimDone || el.dataset.cdsAnimWatching) { continue; }
      if (reduced || !hasIO || ioBroken) {
        revealNow(el);
      } else {
        el.dataset.cdsAnimWatching = '1';
        watched.push(el);
        observe(el);
      }
    }
  }

  function retrigger(root) {
    var els = root.querySelectorAll('[data-cds-anim]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var cls = el.getAttribute('data-cds-anim');
      if (!cls) { continue; }
      el.classList.remove(cls);
      /* force reflow */
      void el.offsetHeight;
      delete el.dataset.cdsAnimDone;
      revealNow(el);
    }
  }

  window.CDSAnim = { scan: scan };

  scan(document);

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var target = e && e.target;
      if (!target || typeof target.querySelectorAll !== 'function') { return; }
      if (target.querySelector('[data-cds-anim]')) {
        retrigger(target);
      }
    });
  }
})();
